const formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })
const signedFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', signDisplay: 'always' })
const amountFormatter = new Intl.NumberFormat('fr-FR')

export const formatCurrency = (amount, { signed = false } = {}) =>
  signed ? signedFormatter.format(amount) : formatter.format(amount)

export const formatAmount = (amount) => amountFormatter.format(amount)

export const formatCompactCurrency = (value) => {
  if (value >= 1000) {
    const k = value / 1000
    return Number.isInteger(k) ? `${k}k€` : `${k.toFixed(1)}k€`
  }
  return `${value}€`
}
